<template>
    <apex-chart ref="groupbar" type="bar" :series="series" :options="chartOptions" height="100%" />
</template>
<script>

  import ApexChart from 'vue-apexcharts'
  import { mixins } from 'vue-chartjs'

  const { reactiveProp } = mixins
  export default {
    components: {
      ApexChart,
    },
    mixins: [reactiveProp],
    data() {
      return {
        series: [],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          dataLabels: { enabled: false },
          plotOptions: {
            bar: { horizontal: false, columnWidth: '55%', distributed: true },
          },
          stroke: { show: true, width: 3, colors: ['transparent'] },
          xaxis: { categories: [], labels: { style: { colors: 'black' } },
          },
          yaxis: {
            labels: {
              style: { colors: '#717171' },
            },
          },
          fill: {
            opacity: 0.95,
          },
          legend: {
            position: 'top',
            labels: {
              colors: '#777777',
            },
          },
        },
      }
    },
    watch: {
      chartData: {
        handler(newVal) {
        const newColors = ['#ffc964', '#03d0e5', '#ef6f4a', '#e3a6e6', '#535b64']

          if (newVal.datasets && newVal.datasets.length >= 1) {
            if (newVal.datasets.length > 1) {
              this.chartOptions.plotOptions.bar.distributed = false
            }
            this.series = []
            this.chartOptions.xaxis.categories = newVal.labels.map(v => (v != null ? v : 'NO_VALUE'))
            for (let i = 0; i < newVal.datasets.length; i++) {
            newColors.every(_color => {
              const random = Math.floor(Math.random() * 5)
              const color = newColors[random]
              const isExistingColor = newVal.datasets.map(e => e.borderColor).includes(color)
              if (isExistingColor) return false

              newVal.datasets[i].borderColor = newColors[random]
              newVal.datasets[i].backgroundColor = newColors[random]
              return true
            })
              const element = {
                name: newVal.datasets[i].label === '' ? newVal.labels[i] : newVal.datasets[i].label,
                data: newVal.datasets[i].data,
                borderColor: newVal.datasets[i].borderColor,
                backgroundColor: newVal.datasets[i].backgroundColor,
              }
              this.series.push(element)
            }
            this.$refs.groupbar.updateSeries(this.series)
            this.$refs.groupbar.updateOptions({
              xaxis: {
                categories: newVal.labels,
              },
            })
          }
          console.log('x  this.chartOptions', this.chartOptions)
        },
        immediate: true,
      },
    },
  }
  </script>

  <style>
  .apexcharts-tooltip {
    background: #f3f3f3;
    color: rgb(59, 59, 58);
  }
  </style>
